import { Fragment } from "react"
import { User } from "@/apis/bff"
import {
  EditBillingInformationActionItem,
  OpenDrawerAppointmentActionItem,
  ShowBillingInformationActionItem,
} from "@/modules/patients/agenda/teleconsultation/appointment-action-menu/appointment-action-menu-item"
import { AppointmentAgenda } from "@/modules/patients/libs/categorize-date-ranges"

type PastAppointmentActionMenuProps = {
  isEditMode: boolean
  rowData: AppointmentAgenda
  user: User
  onClickOpenDrawer: React.MouseEventHandler<HTMLDivElement>
  onClickShowBillingInformation: React.MouseEventHandler<HTMLDivElement>
  onClickEditBillingInformation: React.MouseEventHandler<HTMLDivElement>
}

export const PastAppointmentActionMenu = ({
  isEditMode,
  rowData,
  user,
  onClickOpenDrawer,
  onClickShowBillingInformation,
  onClickEditBillingInformation,
}: PastAppointmentActionMenuProps) => {
  const renderBillingItems = () => {
    if (rowData.status === "CLOSED") {
      const components = [
        {
          key: "ShowBillingInformationActionItemComponent",
          component: <ShowBillingInformationActionItem onClick={onClickShowBillingInformation} />,
        },
      ]

      if (user.isOneOf(["MedicalSupervisor", "CustomerServiceCenter"]) && !rowData.appointment!.isInvoiced) {
        components.push({
          key: "EditBillingInformationActionItemComponent",
          component: <EditBillingInformationActionItem onClick={onClickEditBillingInformation} />,
        })
      }

      return (
        <>
          {components.map((e) => (
            <Fragment key={e.key}>{e.component}</Fragment>
          ))}
        </>
      )
    }
  }

  return isEditMode ? (
    <>
      <OpenDrawerAppointmentActionItem onClick={onClickOpenDrawer} />
      {renderBillingItems()}
    </>
  ) : (
    <>
      <OpenDrawerAppointmentActionItem onClick={onClickOpenDrawer} />
      {rowData.status === "CLOSED" && <ShowBillingInformationActionItem onClick={onClickShowBillingInformation} />}
    </>
  )
}
